import { IconButton, Stack, styled } from "@mui/material";
import { CloseIcon } from "Assets/icons";
import { GrayButton } from "Components/Button";
import Row from "Components/Row";
import { SmText, TextSemibold } from "Components/Text";
import { COLORS } from "constants/layout";
import { useIntl } from "react-intl";

type Props = {
  onClose?: () => void;
};

const QuickRFQFormSuccessful = ({ onClose }: Props) => {
  const t = useIntl();

  return (
    <StyledStack className="card">
      <Row justifyContent="space-between">
        <TextSemibold>
          {t.formatMessage({ id: "your_request_under_review" })}
        </TextSemibold>
        <IconButton className="fit" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Row>

      <SmText color={COLORS.gray[500]} mt={1} mb={2}>
        {t.formatMessage({ id: "thank_for_send_request_desc" })}
      </SmText>

      <Stack textAlign="right" alignItems="flex-end">
        <GrayButton className="ok-btn" onClick={onClose}>
          {t.formatMessage({ id: "ok" })}
        </GrayButton>
      </Stack>
    </StyledStack>
  );
};

const StyledStack = styled(Stack)({
  ".ok-btn": {
    width: "fit-content",
  },
});

export default QuickRFQFormSuccessful;
